import { render, staticRenderFns } from "./CateringRequest.vue?vue&type=template&id=6c44bd68&"
import script from "./CateringRequest.vue?vue&type=script&lang=js&"
export * from "./CateringRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports